import { createContext, useState, useEffect, useContext, ReactNode } from 'react';
import { useDataProvider } from 'react-admin';
import { getLocalStorageId } from './authProvider'; // パスは環境に合わせて調整

interface ApiStatusContextType {
  isApiConnected: boolean;
  setApiConnected: (status: boolean) => void;
  isLoading: boolean;
}

// Contextを作成
export const ApiStatusContext = createContext<ApiStatusContextType>({
  isApiConnected: false,
  setApiConnected: () => {},
  isLoading: true
});

// Contextを提供するためのProviderコンポーネント
export const ApiStatusProvider = ({ children }: { children: ReactNode }) => {
  const [isApiConnected, setApiConnected] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const dataProvider = useDataProvider();

  // アプリケーションの初回読み込み時にAPI連携状態を取得
  useEffect(() => {
    const fetchInitialStatus = async () => {
      const clientId = getLocalStorageId();
      if (!clientId) {
        setIsLoading(false);
        return;
      }
      try {
        const client = await dataProvider.getOne('settings', { id: clientId });
        setApiConnected(client?.data?.apiRelationFlag || false);
      } catch (error) {
        setApiConnected(false);
      } finally {
        setIsLoading(false);
      }
    };
    fetchInitialStatus();
  }, [dataProvider]);

  return (
    <ApiStatusContext.Provider value={{ isApiConnected, setApiConnected, isLoading }}>
      {children}
    </ApiStatusContext.Provider>
  );
};

// Contextを簡単に使うためのカスタムフック
export const useApiStatus = () => useContext(ApiStatusContext);
